"use client";

import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import CaonaboWidget from "./CaonaboWidget";

/**
 * Wrapper que monta el widget solo si la capa chat_text está habilitada.
 * Si la API falla, no renderiza nada (fail-safe).
 * Se oculta en la tienda B2B pública (clientes externos no tienen acceso a Caonabo).
 */
export default function CaonaboWidgetMaybe() {
  const pathname = usePathname();
  const [enabled, setEnabled] = useState<boolean | null>(null);

  // Excluir tienda B2B (pública, clientes externos). Se calcula como flag, NO
  // con early-return antes de los hooks: hacerlo violaba las reglas de hooks
  // ("rendered fewer hooks") y tumbaba el árbol global al navegar desde/hacia
  // /tienda. Los hooks deben ejecutarse siempre; el return condicional va después.
  const hidden = pathname?.startsWith("/tienda") ?? false;

  useEffect(() => {
    if (hidden) return;
    let cancel = false;
    fetch("/api/caonabo/status", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancel) return;
        setEnabled(Boolean(data?.capas?.chat_text));
      })
      .catch(() => {
        if (!cancel) setEnabled(false);
      });
    return () => {
      cancel = true;
    };
  }, [hidden]);

  if (hidden) return null;
  if (!enabled) return null;
  return <CaonaboWidget />;
}
